import React, { useContext } from "react"
import { Link } from "react-router-dom"
import AppContext from "../../../../shared/AppContext"

const BackButton = (props) => {
  const { text, linkTo, model, from } = props
  const { trackEvent } = useContext(AppContext)

  return (
    <Link
      className="model-nav-btn model-back-btn"
      to={linkTo}
      onClick={() => {
        trackEvent("Back to Search", {
          from: from, //link
          to: linkTo,
        })
      }}
    >
      <div>
        <i className="fas fa-chevron-left" style={{ paddingRight: "8px" }}></i>
        {text}
      </div>
    </Link>
  )
}

export default BackButton
